<template>
    <div></div>
  </template>
  
  <script>
  import { mapActions } from 'vuex'
  export default {
  
    name: "TheLogout",
    components: {
      
    },
    data() {
      return {
        
      };
    },
    computed: {
    },
    created() {
      localStorage.removeItem('reloaded');
      this.onLogout()
  
    },
    methods: {
      ...mapActions('authentication', ['logout']),
      onLogout() {
        this.logout();
        this.$router.push({ path: '/' });
      }
    }
  }
  </script>